import { useModalBannersStore } from '~/stores/apostatudo/modal-banners';
import { useResponsiveBannerUrl } from '~/composables/apostatudo/use-responsive-banner-url';

type UtmBannerMap = {
  mobile: string;
  desktop: string;
};

const UTM_SOURCE_BANNERS: Record<string, UtmBannerMap> = {};

export const useModalImage = () => {
  const { currentRouteName } = useRoutes();
  const { modalType, authInitialTab } = storeToRefs(useLayoutStore());

  const imageModalType = computed(() => {
    if (currentRouteName.value === 'register') return 'register';
    if (currentRouteName.value === 'login') {
      return authInitialTab.value === 'register' ? 'register' : 'login';
    }
    if (currentRouteName.value === 'forgot-password') return 'login';
    if (modalType.value === 'forgot-password') return 'login';
    if (modalType.value === 'two-factor-auth') return 'login';
    if (modalType.value === 'login') {
      return authInitialTab.value === 'register' ? 'register' : 'login';
    }

    return modalType.value;
  });

  const modalBannersStore = useModalBannersStore();
  const { isMobile } = useLayout();
  const { isAuthV2FlowEnabled } = useAuth();
  const { utmSource } = useParameters();

  const utmBannerOverride = computed<UtmBannerMap | null>(() => {
    if (!utmSource.value) return null;

    return UTM_SOURCE_BANNERS[utmSource.value] ?? null;
  });

  const isRegisterModal = computed(() => {
    return imageModalType.value === 'register';
  });

  // Busca o banner da nova API quando o tipo do modal muda
  watch(
    [imageModalType, isMobile],
    ([type]) => {
      if (type && typeof type === 'string') {
        modalBannersStore.fetchBanner(type, isMobile.value);
      }
    },
    { immediate: true },
  );

  const bannerImage = computed(() => {
    if (currentRouteName.value === 'pending') {
      return null;
    }

    if (isRegisterModal.value && utmBannerOverride.value) {
      if (!isAuthV2FlowEnabled.value) {
        return getAssetsUrlForCDN(utmBannerOverride.value.mobile);
      }

      return isMobile.value
        ? getAssetsUrlForCDN(utmBannerOverride.value.mobile)
        : getAssetsUrlForCDN(utmBannerOverride.value.desktop);
    }

    const type = imageModalType.value as string;
    const mobile = isMobile.value;

    // Nova API da Aposta Tudo
    const imageUrl = modalBannersStore.getImageUrl(type, mobile);

    if (imageUrl) {
      const { getResponsiveBannerUrl } = useResponsiveBannerUrl();

      return getResponsiveBannerUrl(imageUrl);
    }

    return null;
  });

  const showModalImage = computed(() => {
    return !!bannerImage.value;
  });

  return {
    bannerImage,
    showModalImage,
  };
};
